import React, { useState } from "react"

import "./index.scss"

import { Container, Title, DurationInput, HiddenInput } from "components/Form"
import { ConfigContainer } from "components"
import useT from "utils/hooks/useT"

import { Duration } from "luxon"

// Action connection config used in graph design tool.
export default function ActionConnectionConfig({
  connection,
  actionFrom,
  actionTo,
  submitHandler,
  deleteHandler,
  cancelHandler,
}) {
  const [minTimeBetween, setMinTimeBetween] = useState(
    Duration.fromObject({ seconds: (connection && connection.timeBetween && connection.timeBetween.min) || 0 })
  )
  const [maxTimeBetween, setMaxTimeBetween] = useState(
    connection && connection.timeBetween && connection.timeBetween.max !== null
      ? Duration.fromObject({ seconds: connection.timeBetween.max })
      : null
  )
  const [isWorkdayConnection, setIsWorkdayConnection] = useState(connection.isWorkdayConnection)
  const { t } = useT("common")

  return (
    <ConfigContainer
      title={t("editConnectionFromTo", { from: actionFrom.name, to: actionTo.name })}
      submitHandler={() => {
        submitHandler({
          timeBetween: {
            min: minTimeBetween.as("seconds"),
            max: maxTimeBetween ? maxTimeBetween.as("seconds") : null,
          },
          isWorkdayConnection
        })
      }}
      deleteHandler={deleteHandler}
      cancelHandler={cancelHandler}
      titleInfoText={t("connectionsPerformersOnly")}
    >
      <Container>
        <Title>{t("minTimeBetweenActions")}</Title>
        <DurationInput required withMinutes value={minTimeBetween} onChange={setMinTimeBetween} />
      </Container>
      <Container>
        <Title>{t("maxTimeBetweenActions")}</Title>
        <DurationInput withMinutes value={maxTimeBetween} onChange={setMaxTimeBetween} />
        <em style={{
          color:"grey",
          margin: "0.40em",
        }}>{t("noTimeLimitUnlessSpecified")}</em>
      </Container>
      <Container>
        <Title>{t("connectionCalculatedInWorkdays")}</Title>
        <input
          type="checkbox"
          id="connection-config-checkboxWorkday"
          defaultChecked={isWorkdayConnection}
          onClick={() => {setIsWorkdayConnection(!isWorkdayConnection)}}
        />
      </Container>
      <HiddenInput
        message={
          minTimeBetween && maxTimeBetween && minTimeBetween > maxTimeBetween
            ? t("minTimeMustBeSmallerThanMax")
            : null
        }
      />
    </ConfigContainer>
  )
}
